import "./App.css";
import Ediotor from "./components/Editor";

function App() {
  return (
    <>
      <Ediotor />
    </>
  );
}

export default App;
